module.exports = __webpack_public_path__ + "img/battery.573a31e3.svg";